import { render } from "./ChildDiary.vue?vue&type=template&id=63cfceff&scoped=true&ts=true"
import script from "./ChildDiary.vue?vue&type=script&lang=ts"
export * from "./ChildDiary.vue?vue&type=script&lang=ts"

import "./ChildDiary.vue?vue&type=style&index=0&id=63cfceff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cfceff"]])

export default __exports__